// extracted by mini-css-extract-plugin
export var dataRow = "sensorikForm-module--dataRow--a77a4";
export var selectedFilterBlock = "sensorikForm-module--selectedFilterBlock--21f2b";